import { types } from 'mobx-state-tree';

const UserChangeListItem = types.model('UserChangeListItem', {
    id: types.identifierNumber,
    email: types.maybeNull(types.string),
    created_at: types.maybeNull(types.string),
});

const UserChangeDetail = types.model('UserChangeDetail', {
    id: types.identifierNumber,
    created_at: types.maybeNull(types.string),
    updated_at: types.maybeNull(types.string),
    deleted_at: types.maybeNull(types.string),
    user_id: types.maybeNull(types.number),
    user_email: types.maybeNull(types.string),
    change_type: types.maybeNull(types.string),
    changed_by_admin_id: types.maybeNull(types.number),
    new_fan_name: types.maybeNull(types.string),
    old_fan_name: types.maybeNull(types.string),
    new_fan_name_censored: types.maybeNull(types.boolean),
    old_fan_name_censored: types.maybeNull(types.boolean),
    new_email: types.maybeNull(types.string),
    old_email: types.maybeNull(types.string),
    new_first_name: types.maybeNull(types.string),
    old_first_name: types.maybeNull(types.string),
    new_last_name: types.maybeNull(types.string),
    old_last_name: types.maybeNull(types.string),
    new_street: types.maybeNull(types.string),
    old_street: types.maybeNull(types.string),
    new_zip: types.maybeNull(types.string),
    old_zip: types.maybeNull(types.string),
    new_city: types.maybeNull(types.string),
    old_city: types.maybeNull(types.string),
    new_country: types.maybeNull(types.string),
    old_country: types.maybeNull(types.string),
    new_phone: types.maybeNull(types.string),
    old_phone: types.maybeNull(types.string),
    new_accept_marketing: types.maybeNull(types.boolean),
    old_accept_marketing: types.maybeNull(types.boolean),
    new_on_waiting_list: types.maybeNull(types.boolean),
    old_on_waiting_list: types.maybeNull(types.boolean),
    new_gender: types.maybeNull(types.string),
    old_gender: types.maybeNull(types.string),
    new_avatar: types.maybeNull(types.string),
    old_avatar: types.maybeNull(types.string),
    new_favourite_player_id: types.maybeNull(types.number),
    old_favourite_player_id: types.maybeNull(types.number),
    password_changed: types.maybeNull(types.boolean),
    new_birthday: types.maybeNull(types.string),
    old_birthday: types.maybeNull(types.string),
});

export { UserChangeListItem, UserChangeDetail };
export default UserChangeDetail;
